// Generated by Melange

import * as Caml_string from "melange.js/caml_string.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function printable(value) {
  return Stdlib__String.for_all((function (c) {
    if (c >= 32 && c !== 127) {
      return c !== /* '\\' */92;
    } else {
      return false;
    }
  }), value);
}

function relative(directory, value) {
  if (directory && value === ".") {
    return true;
  } else if (value !== "" && value.length <= 4096 && Caml_string.get(value, 0) !== /* '/' */47 && printable(value)) {
    return Stdlib__List.for_all((function (part) {
      if (part !== "" && part !== ".") {
        return part !== "..";
      } else {
        return false;
      }
    }), Stdlib__String.split_on_char(/* '/' */47, value));
  } else {
    return false;
  }
}

function target(value) {
  if (value === "") {
    return false;
  }
  if (value.length > 1024) {
    return false;
  }
  const match = Caml_string.get(value, 0);
  if (match >= 91 ? !(match > 122 || match < 97) : match >= 65) {
    return Stdlib__String.for_all((function (param) {
      if (param >= 65) {
        if (param > 96 || param < 91) {
          return param < 123;
        } else {
          return param === 95;
        }
      } else if (param > 57 || param < 45) {
        return false;
      } else {
        return param !== 47;
      }
    }), value);
  } else {
    return false;
  }
}

function argument(param) {
  const value = param[1];
  const key = param[0];
  if (key !== "" && key.length <= 128 && Caml_string.get(key, 0) !== /* '-' */45 && !Stdlib__List.mem(key, {
      hd: "OPENAI_API_KEY",
      tl: {
        hd: "CODEX_API_KEY",
        tl: /* [] */ 0
      }
    }) && Stdlib__String.for_all((function (param) {
      return param >= 65 ? (
          param > 96 || param < 91 ? param < 123 : param === 95
        ) : (
          param >= 48 ? param < 58 : param === 45
        );
    }), key) && value.length <= 8192) {
    return !Stdlib__String.contains(value, /* '\000' */0);
  } else {
    return false;
  }
}

function file(path) {
  if (path.TAG === /* Repository */ 0) {
    return relative(false, path._0);
  }
  const content = path.content;
  const name = path.name;
  if (name !== "" && name.length <= 255 && name !== "." && name !== ".." && !Stdlib__String.contains(name, /* '/' */47) && printable(name) && content.length <= 65536) {
    return !Stdlib__String.contains(content, /* '\000' */0);
  } else {
    return false;
  }
}

function validate(config) {
  if (/* tag */ typeof config !== "object" && typeof config !== "function") {
    return {
      TAG: /* Ok */ 0,
      _0: undefined
    };
  }
  const config$1 = config._0;
  if (file(config$1.dockerfile) && relative(true, config$1.context) && Stdlib__Option.fold(true, target, config$1.target) && Stdlib__List.length(config$1.build_args) <= 64 && Stdlib__List.for_all(argument, config$1.build_args) && Stdlib__List.length(Stdlib__List.sort_uniq(Stdlib__String.compare, Stdlib__List.map((function (prim) {
      return prim[0];
    }), config$1.build_args))) === Stdlib__List.length(config$1.build_args)) {
    return {
      TAG: /* Ok */ 0,
      _0: undefined
    };
  } else {
    return {
      TAG: /* Error */ 1,
      _0: "invalid_environment_configuration"
    };
  }
}

export {
  validate,
}
/* No side effect */
